import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-card',
  templateUrl: './skeleton-card.component.html',
  styleUrls: ['./skeleton-card.component.scss']
})
export class SkeletonCardComponent implements OnInit {

  typeName = {
    'ONLINE': 'En linea',
    'INSITE': 'Presencial',
    'HYBRID': 'Hibrido'
  }

  constructor() { }

  ngOnInit(): void {
  }

}
